import * as T from "../../utilities/frontendTypes";
import { apiGet, apiPut } from "../apiClient";

/*
  Portal Control Services
*/

export async function getNewMemberAcceptanceStatus(): Promise<T.HTTPResponse> {
  return apiGet<T.HTTPResponse>("/api/admins/new-member-acceptance-status");
}

export async function updateNewMemberAcceptanceStatus(status: "active" | "inactive"): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/new-member-acceptance-status", { status });
}

// Server projects founder rows to the fields actually consumed (NoProfile
// table: email/createdAt) plus the bucket-filter field — not full User docs.
export type RegionFounderRow = Pick<T.User, "_id" | "email" | "founderStatus" | "createdAt">;

export async function getRegionFounderDetailsAsync(): Promise<{success: boolean, regionalFounderDetails: {membershipApplications: number, regionalFounders: RegionFounderRow[], foundersWithNoApplications: RegionFounderRow[], uninvited: RegionFounderRow[], dueDiligence: RegionFounderRow[]}}> {
  return apiGet<{success: boolean, regionalFounderDetails: {membershipApplications: number, regionalFounders: RegionFounderRow[], foundersWithNoApplications: RegionFounderRow[], uninvited: RegionFounderRow[], dueDiligence: RegionFounderRow[]}}>("/api/admins/region-founder-details");
}


export async function getRegionExpertStatsAsync(): Promise<{success: boolean, regionalExpertDetails: {uninvited: number, inProgress: number, preMeeting: number, awaitingApproval: number}}> {
  return apiGet<{success: boolean, regionalExpertDetails: {uninvited: number, inProgress: number, preMeeting: number, awaitingApproval: number}}>("/api/admins/region-expert-details");
}

export interface RegionalDashboardStats {
  unsubmitted: number;
  allStartup: number;
  awaitingReview: number;
  ipaInviteSent: number;
  ipaAssessmentReady: number;
  awaitingGcAssessment: number;
  gcAssessmentReady: number;
  sowRequested: number;
  sowAwaitingIpaReview: number;
  sowAwaitingAoReview: number;
  sowReadyForAudit: number;
  sowReadyForSignature: number;
  sowSigned: number;
  invoicesAwaitingReview: number;
  projectCompleted: number;
}

export async function getRegionStatsAsync(): Promise<{success: boolean, regionalDetails: RegionalDashboardStats}> {
  return apiGet<{success: boolean, regionalDetails: RegionalDashboardStats}>("/api/admins/region-details");
}

export async function getFirmsAsync(): Promise<{success: boolean, firms: {value: string, text: string}[]}> {
  return apiGet<{success: boolean, firms: {value: string, text: string}[]}>("/api/admins/get-region-firms");
}

export async function reassignRegionService(applicationId: string, targetRegion: string): Promise<{success: boolean; message: string}> {
  return apiPut<{success: boolean; message: string}>("/api/admins/reassign-region", { applicationId, targetRegion });
}

// Region Settings

export async function getRegionSettings(): Promise<T.HTTPResponse> {
  return apiGet<T.HTTPResponse>("/api/admins/region-settings");
}

export async function updateRegionSettings(data: {
  retainerInvoiceEnabled?: boolean;
  embeddedSigningEnabled?: boolean;
  applicationIntake?: {
    isOpen: boolean;
    startDate: string | null;
    endDate: string | null;
    closedTitle: { eng: string; fr: string };
    closedMessage: { eng: string; fr: string };
  };
  productCapOverrides?: Record<string, { soft: number | null; hard: number | null }>;
  hourlyRateSoftCap?: number;
  intakeAllowlistEmails?: string[];
}): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/region-settings", data);
}

export async function getPortalMode(region: string): Promise<T.HTTPResponse & { data?: { fullPortalEnabled: boolean } }> {
  return apiGet<T.HTTPResponse & { data?: { fullPortalEnabled: boolean } }>(`/api/admins/region-settings/${region}/portal-mode`);
}

export async function updatePortalMode(region: string, fullPortalEnabled: boolean): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>(`/api/admins/region-settings/${region}/portal-mode`, { fullPortalEnabled });
}
